<template>
  <!-- new -->
  <div class="wrapp light-bg" id="booking-widget">
    <div class="container bv-example-row room-list  content-body ">
      <!-- test -->
      <div class="row">
        <div class="col-md-4 col-sm-4 col-4"></div>
        <div class="col-md-4 col-sm-4 col-4">
          <div class="loader" v-show="!pageloader">
            <loader-terms></loader-terms>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-4"></div>
      </div>
      <div class="row" v-show="pageloader">
        <div class="col-md-8 col-sm-12 col-12">
          <!-- alert -->
          <div id="alert-msg" class="ui-pnotify ui-pnotify-inline hotel" aria-live="assertive" aria-role="alertdialog"
            v-if="step ==1">
            <div class="notify-container" role="alert" style="min-height: 16px;">
              <div class="notify-icon">
                <span class="fa fa-bell-o faa-ring animated"></span>
              </div>
              <h4 class="notify-title">enhance your stay</h4>
              <div class="notify-text" aria-role="alert">
                We're happy to offer a few extra perks to help enhance your stay. These items can be added to your
                reservation during the booking process.
              </div>
              <div class="row">
                <div class="col-md-4 col-sm-4 col-4"></div>
                <div class="col-md-4 col-sm-4 col-4"></div>
                <div class="col-md-4 col-sm-4 col-4">
                  <button class="pnotify-action-button" :disabled="clicked" type="button" @click.prevent="next()">Skip
                    This Step</button>
                </div>

              </div>
            </div>
          </div>
          <!-- for booking detail -->
          <div id="alert-msg" class="ui-pnotify ui-pnotify-inline hotel" aria-live="assertive" aria-role="alertdialog"
            v-if="step ==2">
            <div class="notify-container" role="alert" style="min-height: 16px;">
              <div class="notify-icon">
                <span class="fa fa-bell-o faa-ring"></span>
              </div>
              <h4 class="notify-title" v-if="!manageBooking">booking details</h4>
              <h4 class="notify-title" v-else>update booking details</h4>
              <div class="notify-text" aria-role="alert" v-if="!manageBooking">
                We need your personal details to complete the booking. Kindly do fill in the form below and also confirm
                that the room, number of guests and dates selected are correct. Once all is well, click "Confirm
                Booking" to proceed with your reservation.
              </div>
              <div class="notify-text" aria-role="alert" v-else>
                Kindly confirm that the dates selected are correct. Once all is well, click "Update Booking" to proceed
                with your booking update.
              </div>
            </div>
          </div>
          <!-- end alert -->
          <div class="vue-card-unit" v-show="step == 1" v-for="enhancement in addedhenancement"
            :key="enhancement.enhancementData.id">
            <div>
              <div class="row">
                <div class="col-md-5 col-sm-12 col-12">
                  <img :src="enhancement.enhancementData.image" :alt="enhancement.enhancementData.name"
                    class="responsive" />
                </div>
                <div class="col-md-7 col-sm-12 col-12 unit-body-detail">
                  <div class="pad-content-header">
                    <h6><b>{{enhancement.enhancementData.name}}</b></h6>
                    <p>{{enhancement.enhancementData.description}}</p>
                  </div>
                  <div class="vue-loading-cover" :id="'loading-cover-'+enhancement.enhancementData.id">
                    <div class="row pad-content">
                      <!-- resident -->
                      <div class="col-md-12 col-sm-12 col-12" id="sub-content">
                        <div class="enh-price-row">
                          <div class="enh-price-info">
                            <div v-if="proofRes == 0">
                              <span v-if="enhancement.enhancementData.rates.hasOwnProperty('fixed') !==false">
                                <strong>{{ bookingData.data[propertyid].currency.res }}
                                  {{enhancement.enhancementData.rates.fixed.res}} </strong></span>
                              <span v-else>
                                <div>
                                  <small class="startingfrom">Price starts from</small>
                                  <div class="enh-price">
                                    <strong>{{ bookingData.data[propertyid].currency.res }}
                                      {{enhancement.enhancementData.rates.perUser.adults.res}} </strong>
                                    <small v-if="enhancement.enhancementData.rates.perUser.adultCount >1">For
                                      {{enhancement.enhancementData.rates.perUser.adultCount}} Adult</small> <small
                                      v-else>Per Adult</small> <br>
                                    <div
                                      v-if="enhancement.enhancementData.childrenAllowed !==0 && enhancement.enhancementData.rates.perUser.children.res >0">
                                      <strong>{{ bookingData.data[propertyid].currency.res }}
                                        {{enhancement.enhancementData.rates.perUser.children.res}} </strong>
                                      <small v-if="enhancement.enhancementData.rates.perUser.childCount ==1">Per
                                        children</small> <small v-else>For
                                        {{enhancement.enhancementData.rates.perUser.childCount}} children</small>
                                    </div>
                                  </div>
                                </div>
                              </span>
                              <span class="vat">{{bookingData.data[propertyid].vat.enhancement_price}} of all govt
                                taxes</span>
                            </div>
                            <div v-if="proofRes == 1">
                              <span v-if="enhancement.enhancementData.rates.hasOwnProperty('fixed') !==false">
                                <strong>{{ bookingData.data[propertyid].currency.nonres }}
                                  {{enhancement.enhancementData.rates.fixed.nonres}} </strong></span>
                              <span v-else>
                                <div>
                                  <small class="startingfrom">Price starts from</small>
                                  <div class="enh-price">
                                    <strong>{{ bookingData.data[propertyid].currency.nonres }}
                                      {{enhancement.enhancementData.rates.perUser.adults.nonres}} </strong>
                                    <small v-if="enhancement.enhancementData.rates.perUser.adultCount >1">For
                                      {{enhancement.enhancementData.rates.perUser.adultCount}} Adult</small> <small
                                      v-else>Per Adult</small> <br>
                                    <div
                                      v-if="enhancement.enhancementData.childrenAllowed !==0 && enhancement.enhancementData.rates.perUser.children.nonres >0">
                                      <strong>{{ bookingData.data[propertyid].currency.nonres }}
                                        {{enhancement.enhancementData.rates.perUser.children.nonres}} </strong>
                                      <small v-if="enhancement.enhancementData.rates.perUser.childCount ==1">Per
                                        children</small> <small v-else>For
                                        {{enhancement.enhancementData.rates.perUser.childCount}} children</small>
                                    </div>
                                  </div>
                                </div>
                              </span>
                              <span class="vat">{{bookingData.data[propertyid].vat.enhancement_price}} of all govt
                                taxes</span>
                            </div>
                          </div>
                          <div class="enh-price-total">
                            <div v-if="enhancement.enhancementData.enhancementprice">
                              <strong v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}
                                {{formatPrice(enhancement.enhancementData.enhancementprice.res)}}</strong>
                              <strong v-if="proofRes == 1">{{ bookingData.data[propertyid].currency.nonres }}
                                {{formatPrice(enhancement.enhancementData.enhancementprice.nonres)}}</strong>
                            </div>
                            <div v-else>
                              <strong v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}</strong>
                              <strong v-else>{{ bookingData.data[propertyid].currency.nonres }}</strong>
                              <strong>0.0</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 col-12" id="sub-content">
                        <div v-if="enhancement.enhancementData.unitSelection == 0 ">
                          <span><strong>Add This</strong></span> <br>
                          <label class="switch">
                            <input type="checkbox" @click="addEnhancement($event,enhancement.enhancementData)">
                            <span class="slider"></span>
                          </label>
                        </div>
                        <div v-else>
                          <div class="row">
                            <div class="col-md-4 col-sm-12 col-12 col-4">
                              <span><strong>{{enhancement.enhancementData.unit.title ?
                                  enhancement.enhancementData.unit.title : 'Unit'}}</strong></span>
                              <div class="enhancement-btngrp">
                                <button type="button" class="vue-btnb" @click="removeUnit(enhancement.enhancementData)"
                                  :disabled="clicked">
                                  <i class="fa fa-minus"></i>
                                </button>
                                <input disabled="disabled" class="vue-fxcount"
                                  :id="'unit'+enhancement.enhancementData.id" value="0" name="babiesfx" type="text" />
                                <button type="button" class="vue-btnb  " @click="addUnit(enhancement.enhancementData)"
                                  :disabled="clicked">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                              <span v-if="uniterror == enhancement.enhancementData.id" style="color:red"><small> Please
                                  add {{enhancement.enhancementData.unit.title ? enhancement.enhancementData.unit.title
                                  : "unit"}} </small></span>
                            </div>
                            <div class="col-md-4 col-sm-12 col-12 col-4"
                              v-if="enhancement.enhancementData.rates.hasOwnProperty('fixed') ==false">
                              <span v-if="enhancement.enhancementData.adultsAllowed !==0"><strong>Adults</strong></span>
                              <div class="enhancement-btngrp" v-if="enhancement.enhancementData.adultsAllowed !==0">
                                <button type="button" class="vue-btnb" @click="removeAdult(enhancement.enhancementData)"
                                  :disabled="clicked">
                                  <i class="fa fa-minus"></i>
                                </button>
                                <input disabled="disabled" class="vue-fxcount"
                                  :id="'adults'+enhancement.enhancementData.id" value="1" name="babiesfx" type="text" />
                                <button type="button" class="vue-btnb  " @click="addAdult(enhancement.enhancementData)"
                                  :disabled="clicked">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>

                            </div>
                            <div class="col-md-4 col-sm-12 col-12 col-4"
                              v-if="enhancement.enhancementData.rates.hasOwnProperty('fixed') ==false">
                              {{enhancement.enhancementData.children}}
                              <span
                                v-if="enhancement.enhancementData.childrenAllowed !==0"><strong>Children</strong></span>
                              <div class="enhancement-btngrp" v-if="enhancement.enhancementData.childrenAllowed !==0">
                                <button type="button" @click="removeChildren(enhancement.enhancementData)"
                                  class="vue-btnb " :disabled="clicked">
                                  <i class="fa fa-minus"></i>
                                </button>
                                <input disabled="disabled" class="vue-fxcount"
                                  :id="'children'+enhancement.enhancementData.id" value="0" type="text" />
                                <button type="button" class="vue-btnb" @click="addChildren(enhancement.enhancementData)"
                                  :disabled="clicked">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 col-12" id="sub-content"
                        v-if="enhancement.enhancementData.specialRequests.allow ==1">
                        <label for="enhancementDetail">{{enhancement.enhancementData.specialRequests.label}}</label>
                        <textarea class="form-control enhancement_form" cols="40" rows="2"
                          @change="addspecialrequest($event,enhancement.enhancementData)"></textarea>
                      </div>
                    </div>
                    <span class="vue-loading" :id="'loading-'+enhancement.enhancementData.id" style="display:none;">
                      <!-- <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i><br>loading ... -->
                      <i class="fa fa-spinner fa-spin" id="spinnerl" style="font-size:24px;color:#ff6600;"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div v-show="step == 2">
              <div class="booking-summary-bar">
                <div class="booking-summary-bar-row" v-show="showBookingSummary">
                  <div class="booking-summary-bar-item">
                    <span class="booking-summary-bar-label">{{ bookingData.data[propertyid].room_label.singular }}</span>
                    <span class="booking-summary-bar-value">{{ room.name }}</span>
                  </div>
                  <div class="booking-summary-bar-item">
                    <span class="booking-summary-bar-label">Check-in</span>
                    <span class="booking-summary-bar-value">{{ checkinDate }}</span>
                  </div>
                  <div class="booking-summary-bar-item">
                    <span class="booking-summary-bar-label">Check-out</span>
                    <span class="booking-summary-bar-value">{{ checkoutDate }}</span>
                  </div>
                  <div class="booking-summary-bar-item">
                    <span class="booking-summary-bar-label">Guests</span>
                    <span class="booking-summary-bar-value">{{ adults }} Adult<span v-if="adults > 1">s</span><span
                        v-if="children > 0">, {{ children }} Child<span v-if="children > 1">ren</span></span></span>
                  </div>
                  <div class="booking-summary-bar-item booking-summary-bar-total">
                    <span class="booking-summary-bar-label">Total</span>
                    <span class="booking-summary-bar-value">
                      <span v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}
                        {{ formatPrice(roomtotal.res) }}</span>
                      <span v-if="proofRes == 1">{{ bookingData.data[propertyid].currency.nonres }}
                        {{ formatPrice(roomtotal.nonres) }}</span>
                    </span>
                  </div>
                </div>
                <div class="booking-summary-bar-actions">
                  <button type="button" class="booking-summary-bar-toggle" @click="showBookingSummary = !showBookingSummary"
                    :aria-expanded="showBookingSummary.toString()" aria-label="Toggle booking summary">
                    <i class="fa" :class="showBookingSummary ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </button>
                  <button type="button" class="booking-summary-bar-edit" @click.prevent="editSelection">
                    <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                  </button>
                </div>
              </div>
              <form autocomplete="on">
                <div class="vue-booking-form">
                  <!-- Only display these fields if
                              its fresh booking -->
                  <div v-if="!manageBooking">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group" :class="{ 'form-group--error': $v.first_name.$error }">
                          <label for="first_name">First Name: <span style="color:red">*</span></label>
                          <input type="text" v-model="$v.first_name.$model" class="form-control" id="first_name"
                            :class='{"form_error": $v.first_name.$error}' />
                          <div class="form__error" v-if='$v.first_name.$error'
                            :class='{"form__input-error": $v.first_name.$error}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                          <label for="last_name">Last Name: <span style="color:red">*</span></label>
                          <input type="text" v-model="$v.last_name.$model" class="form-control" id="last_name"
                            :class='{"form_error": $v.last_name.$error}' />
                          <div class="form__error" v-if='$v.last_name.$error'
                            :class='{"form__input-error": $v.last_name.$error}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.surname_selection !== 0">
                        <div class="form-group">
                          <label for="first_name">Surname:</label>
                          <input type="text" v-model="surname" class="form-control" id="first_name" />
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.date_of_birth_selection !== 0">
                        <div class="form-group">
                          <label for="first_name">Date of Birth:</label>
                          <input type="text" v-model="dateOfBirth" class="form-control" id="first_name" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                          <label for="email">Email address: <span style="color:red">*</span></label>
                          <input type="email" v-model="$v.email.$model" class="form-control"
                            :class='{"form_error": $v.email.$error}' id="email" />
                          <div class="form__error" v-if='$v.email.$error'
                            :class='{"form__input-error": $v.email.$error}'>
                            <div v-if="!$v.email.required">
                              *This field is required.
                            </div>
                          </div>
                          <div v-if="email !== ''">
                            <div class="form__input-error" v-if='!$v.email.email'>
                              this email is not valid
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                          <label for="email">Confirm Email: <span style="color:red">*</span></label>
                          <input type="email" class="form-control" v-model="emailConfirm" id="email"
                            :class='{"form_error": $v.emailConfirm.$error}' />
                          <div v-if="email !== '' && emailConfirm !== ''">
                            <div class="form__error" v-if='$v.emailConfirm.$error'
                              :class='{"form__input-error": $v.emailConfirm.$error}'>
                              *email are not the same.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.nationality_selection !== 0">
                        <div class="form-group">
                          <label for="nationality">Nationality: <span
                              v-if="bookingData.data[propertyid].guest_form_settings.nationality_selection === 2"
                              style="color:red">*</span></label><br />
                          <select name="" v-model="nationality"
                            :class="nationalityError ?'form-control form_error':'form-control'">
                            <option v-for="country in countries" :key="country.id" :value="country.id">
                              {{country.nicename}}</option>
                          </select>
                          <div class="form__error" v-if='nationalityError'
                            :class='{"form__input-error": nationalityError}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                          <label for="phone">Phone No (eg +254 723 *** ***) : <span style="color:red">*</span></label>
                          <input type="text" v-model="$v.phone.$model" class="form-control" :class='{"form_error": $v.phone.$error}' id="phone" @input="verifyPhoneNumber($v.phone.$model)" />
                        </div>
                        <div class="form__error" v-if='$v.phone.$error' :class='{"form__input-error": $v.phone.$error}'>
                          *This field is required.
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.proof_of_residency_selection !== 0">
                        <div class="form-group">
                          <label for="proof_of_residency">Proof of residency to present upon check-in:</label>
                          <div>
                            <label class="radio-inline"><input @click="proofOfRes(1)" v-model="proof_of_residency"
                                type="radio" value="National ID" id="proof_of_residency" name="proof_of_residency" />
                              &nbsp;National ID</label>
                            <label class="radio-inline"><input @click="proofOfRes(2)" type="radio" value="Passport"
                                v-model="proof_of_residency" name="proof_of_residency"
                                :class='{"form__input-error": proofOfResidencyError}' />&nbsp; Passport</label>
                          </div>
                          <div class="form__error" v-if='proofOfResidencyError'
                            :class='{"form__input-error": proofOfResidencyError}'>
                            *This field is required.
                          </div>
                          <div>
                            <input type="text" v-model="proof_of_res_number" :placeholder="residence_proof_placeholder"
                              :class="proofOfResNumber? 'form-control form_error': 'form-control' "
                              :disabled="proof_of_residency_disabled" :required="residence_proof_required" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.gender_selection !== 0">
                        <div class="form-group">
                          <label>Gender: </label>
                          <select v-model="gender" id="" :class="genderError?'form-control form_error':'form-control'">
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                          <div class="form__error" v-if='genderError' :class='{"form__input-error": genderError}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- {{bookingData.data[propertyid].guest_form_settings}} -->
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.allow_checkin_selection == 1">
                        <div class="form-group">
                          <label>Arrival Time: <span
                              v-if="bookingData.data[propertyid].guest_form_settings.checkin_selection_mandatory==1"
                              style="color:red">*</span></label>
                          <select v-model="arrival_time"
                            :class="arrivalTimeError? 'form-control form_error' :'form-control'">
                            <option value="">Arrival Time</option>
                            <option v-for="(arrivalTime, atimeindex) in arrivalTimelist" :key="atimeindex"
                              :value="arrivalTime.time24">- {{arrivalTime.time12}} </option>
                            <option value="N/A">- Unknown</option>
                          </select>
                          <div class="form__error" v-if='arrivalTimeError'
                            :class='{"form__input-error": arrivalTimeError}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.allow_checkout_selection == 1">
                        <div class="form-group">
                          <label>Departure Time: <span
                              v-if="bookingData.data[propertyid].guest_form_settings.checkout_selection_mandatory==1"
                              style="color:red">*</span></label>
                          <select v-model="departure_time"
                            :class="departureTimeError?'form-control form_error':'form-control'">
                            <option value="">Departure Time</option>
                            <option v-for="(derpatureTime, dtimeindex) in derpatureTimelist" :key="dtimeindex"
                              :value="derpatureTime.time24">- {{derpatureTime.time12}}</option>
                            <option value="N/A">- Unknown</option>
                          </select>
                          <div class="form__error" v-if='departureTimeError'
                            :class='{"form__input-error": departureTimeError}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 col-12"
                        v-if="bookingData.data[propertyid].guest_form_settings.purpose_of_visit_selection !== 0">
                        <div class="form-group">
                          <label for="email">Purpose of visit: <span
                              v-if="bookingData.data[propertyid].guest_form_settings.purpose_of_visit_selection === 2"
                              style="color:red">*</span></label>
                          <div>
                            <label><input type="radio" value="Leisure" v-model="purpose_of_visit"
                                :class='puporseOfVistError? "form_error":""' />
                              &nbsp; Leisure</label>
                          </div>
                          <div>
                            <label><input type="radio" value="Business" v-model="purpose_of_visit"
                                :class='{"form__input-error": puporseOfVistError}' />&nbsp; Business</label>
                          </div>
                          <div class="form__error" v-if='puporseOfVistError'
                            :class='{"form__input-error": puporseOfVistError}'>
                            *This field is required.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                          <label>Special Request:</label>
                          <textarea v-model="Special_request" id="" class="form-control" cols="30" rows="2"
                            :placeholder="specialRequestPlaceholder"></textarea>
                        </div>
                      </div>
                    </div>
                    <reserveport-loyalty v-if="isValidPhone && loyaltyIsEnabled" :phonenumber="this.phone" :propertyid='this.propertyid' :paytotal='this.payablecTotal' :currency='this.bookingCurrency' :res_nonres='this.proofRes == 0 ? "res" : "nonres"' ></reserveport-loyalty>
                  </div>
                  <div class="row footer-frm" style="background-color: #ffffff; margin: 15px -15px; padding: 10px 0">
                    <div class="col-md-12 radio_inline" v-if="bookingData.data[propertyid].allow_pay_on_arrival ==1 ">
                      <label><input type="radio" v-model="$v.chargeType.$model" value="offline" />
                        &nbsp;<strong> Pay On Arrival <small>( <span v-if="proofRes == 0">{{
                              bookingData.data[propertyid].currency.res }}</span> <span v-else>{{
                              bookingData.data[propertyid].currency.nonres }}</span>
                            {{formatPrice(payOnArrival)}})</small>
                        </strong>
                        <div>
                          <small>
                            &nbsp; &nbsp; &nbsp; &nbsp;- Please note this
                            reservation will not be fully confirmed. Confirmation
                            will be upon check-in.</small>
                          <br>
                          <small v-if="extraCharge > 0">
                            &nbsp; &nbsp; &nbsp; &nbsp;- Pay On Arrival attracts an extra charges of <strong> <span
                                v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}</span> <span
                                v-else>{{ bookingData.data[propertyid].currency.nonres }}</span>
                              {{formatPrice(extraCharge)}}</strong>.</small>
                          <br />
                          <hr />
                        </div>
                      </label>
                    </div>

                    <div v-if="this.board.is_special_offer_rate">
                      <div class="col-md-12 radio_inline"
                        v-if="this.board.special_rate_percentage > 0 && this.board.special_rate_percentage < 100">
                        <label><input type="radio" value="deposit" v-model="$v.chargeType.$model" />
                          &nbsp;<strong> Pay {{ this.board.special_rate_percentage }}% deposit now to
                            secure
                            your reservation.
                            <small>( <span v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}</span>
                              <span v-else>{{ bookingData.data[propertyid].currency.nonres }}</span>
                              {{ formatPrice(deposit) }})</small>
                          </strong>
                          <div>
                            <small>&nbsp; &nbsp; &nbsp; &nbsp; - Balance to be paid on a
                              later date. Pay using Visa, MasterCard, AMEX or Mobile
                              Money
                            </small>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div v-if="!bookingData.data[propertyid].guest_form_settings.pay_at_property_only">
                      <div class="col-md-12 radio_inline"
                        v-if="bookingData.data[propertyid].deposit_percentage > 0 && bookingData.data[propertyid].deposit_percentage < 100 && this.board.is_special_offer_rate === 0">
                        <label><input type="radio" value="deposit" v-model="$v.chargeType.$model" />
                          &nbsp;<strong> Pay {{ bookingData.data[propertyid].deposit_percentage }}% deposit now to secure
                            your reservation.
                            <small>( <span v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}</span>
                              <span v-else>{{ bookingData.data[propertyid].currency.nonres }}</span>
                              {{ formatPrice(deposit) }})</small>
                          </strong>
                          <div>
                            <small>&nbsp; &nbsp; &nbsp; &nbsp; - Balance to be paid on a
                              later date. Pay using Visa, MasterCard, AMEX or Mobile
                              Money
                            </small>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div v-if="!bookingData.data[propertyid].guest_form_settings.pay_at_property_only" class="col-md-12 radio_inline">
                      <label><input type="radio" v-model="$v.chargeType.$model" value="full" checked />
                        &nbsp; <strong> Pay full amount now to secure your reservation.
                          <small>( <span v-if="proofRes == 0">{{ bookingData.data[propertyid].currency.res }}</span>
                            <span v-else>{{ bookingData.data[propertyid].currency.nonres }}</span>
                            {{formatPrice(payablecTotal)}})</small>
                        </strong>
                        <div>
                          <small>&nbsp; &nbsp; &nbsp; &nbsp;- Pay securely using
                            Visa,MasterCard,AMEX or Mobile Money</small>
                        </div>
                      </label>
                    </div>
                    <div class="form__error" v-if='$v.chargeType.$error'
                      :class='{"form__input-error": $v.chargeType.$error}'>
                      *This field is required.
                    </div>
                    <div class="col-md-12 check-border">
                      <label>
                        <input type="checkbox" v-model="$v.acceptedterm.$model" value="accepted" />
                        I accept the
                        <a href="javascript:void(0)" @click="openTermsAndCondition" role="button"
                          v-if="bookingData.data[propertyid].terms !==''">Terms and Conditions
                        </a>
                        <span v-else>
                          Terms and Conditions
                        </span>
                      </label>
                      <div class="form__error" v-if='$v.acceptedterm.$error'
                        :class='{"form__input-error": $v.acceptedterm.$error}'>
                        please accept terms and condtion.
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button class="btn_confirm btn btn-orange-solid" @click.prevent="completeBook"
                        :disabled="submitStatus == 'PENDING'">
                        <div v-show="isProcessing">
                          <span v-html="spinner"></span>
                        </div>
                        <div v-show="!isProcessing" v-if="!manageBooking">CONFIRM BOOKING</div>
                        <div v-show="!isProcessing" v-else>UPDATE BOOKING</div>
                      </button>
                    </div>
                    <div class="modal" id="myTerms" role="dialog" aria-labelledby="myModalLabel">
                      <div class="modal-dialog">
                        <button type="button" class="close" data-dismiss="modal">
                          <i class="fa fa-close" style="font-size:48px;color:red"></i>
                          <span class="sr-only">Close</span>
                        </button>
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">
                              Terms and Conditions
                            </h4>
                          </div>
                          <div class="modal-body">
                            <div>
                              <div v-html="bookingData.data[propertyid].terms">
                              </div>
                            </div>
                            <div v-if="bookingData.data[propertyid].cancellation_policies !==''">
                              <h4>Cancellation Policies</h4>
                              <div v-html="bookingData.data[propertyid].cancellation_policies"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div id="importantNotes" class="col-md-12 terms_section"
                    v-if="bookingData.data[propertyid].terms !==''">
                    <div class="bs-notice">
                      <div class="panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading" @click="openAccordion" style="cursor: pointer;">
                            <h4 class="panel-title">
                              Terms and Conditions
                            </h4>
                          </div>
                          <transition name="fade">
                            <div id="termsAndConditions" v-show="accordion">
                              <div class="panel-body">
                                <div v-html="bookingData.data[propertyid].terms"></div>
                                <div v-if="discount_terms.length > 0">
                                  <h6 id="discount_terms">Discount Terms & Conditions</h6>
                                  <div v-html="discount_terms"></div>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="importantNotes" class="col-md-12"
                    v-if="bookingData.data[propertyid].cancellation_policies !==''">
                    <div class="bs-notice">
                      <div class="panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading" @click="opencancelAccordion" style="cursor: pointer;">
                            <h4 class="panel-title">
                              Cancellation Policy
                            </h4>
                          </div>
                          <transition name="fade">
                            <div id="termsAndConditions" v-show="cancpolicyaccodion">
                              <div class="panel-body">
                                <div v-html="bookingData.data[propertyid].cancellation_policies"></div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </transition>
        </div>
        <!-- rigth side conten -->

        <div class="col-md-4 col-sm-12 col-12">
          <div class="vue-right-side">
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_top_card">
                  <h3>
                    {{ bookingData.data[propertyid].name }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_bottom_card">
                  <h3>SUMMARY</h3>
                  <div class="row">
                    <div class="col-md-2">
                      <img id="bedimg" :src="'https://reservations.reserveport.com/static/img/logo.png'" width="65">
                    </div>
                    <div class="header-content col-md-10 ol-sm-12 col-12" style="text-align: left !important">
                      <span><strong>Adult:</strong> {{adults}} <br /></span>
                      <span v-if="children > 0"><strong>Children:</strong> {{children}} <br></span>
                      <span><strong>Check-in:</strong>&nbsp;{{ checkinDate }} <br /></span>
                      <span><strong>Check-out:</strong>&nbsp;{{ checkoutDate }} <br /></span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div>
                        <table id="room_details_1" class="table table-small-font  table-responsive mrgb5">
                          <thead>
                            <tr>
                              <th style="text-align: left" width="10%">
                                {{bookingData.data[this.propertyid].room_label.singular}} details</th>
                              <th width="10%" style="text-align: left">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td width="10%" class="prclabel">
                                {{ room.name }}
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">

                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>
                                    {{ formatPrice(roomtotal.res) }}
                                  </span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>
                                    {{ formatPrice(roomtotal.nonres) }}
                                  </span>

                                </div>
                              </td>
                            </tr>
                            <tr v-if="discount_value.res > 0 || discount_value.nonres > 0">
                              <td width="10%" class="prclabel">
                                <b>Discount</b>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>
                                    {{ formatPrice(discount_value.res) }}
                                  </span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>
                                    {{ formatPrice(discount_value.nonres) }}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="Object.keys(selectedEnhancement).length !==0">
                        <table class="table table-small-font  table-responsive mrgb5">
                          <thead>
                            <tr>
                              <th style="text-align: left" width="10%">Enhancement Details</th>
                              <th width="10%"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(adhance, eindex) in selectedEnhancement" :key="eindex">
                              <td class="prclabel">
                                {{adhance.data.enhancementName}}
                              </td>
                              <td style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{ formatPrice(adhance.data.enhancementPrice.res) }}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{ formatPrice(adhance.data.enhancementPrice.nonres) }}</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <table class="table table-small-font  table-responsive mrgb5">
                          <tbody>
                            <tr v-if="serviceCharge.res > 0 || serviceCharge.nonres > 0">
                              <td width="10%" class="prclabel"><b> SERVICE CHARGES</b> &nbsp;
                                <span class="tool-tip"
                                  v-if="bookingData.data[propertyid].extra_charges.service_charge.is_percentage_based ==1">
                                  <i class="fa fa-info-circle" @mouseover="servicechrg = true"
                                    @mouseleave="servicechrg = false"></i>
                                </span>
                                <div class="tax-tooltip" v-show="servicechrg">
                                  <i class="fa fa-info"></i> <span class="tooltip-header">Service Charge</span><br>
                                  <p v-if="proofRes == 0">
                                    {{bookingData.data[propertyid].extra_charges.service_charge.value.res}}% service
                                    charge</p>
                                  <p v-if="proofRes == 1">
                                    {{bookingData.data[propertyid].extra_charges.service_charge.value.nonres}}% service
                                    charge</p>
                                </div>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  &nbsp;
                                  <span>{{ formatPrice(serviceCharge.res) }}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  &nbsp;
                                  <span>{{ formatPrice(serviceCharge.nonres) }}</span>

                                </div>
                              </td>
                            </tr>
                            <tr v-if="totalVat.res > 0 || totalVat.nonres > 0">
                              <td width="10%" class="prclabel"><b> TOTAL VAT</b>&nbsp;
                                <span class="tool-tip">
                                  <i class="fa fa-info-circle" @mouseover="taxhover = true"
                                    @mouseleave="taxhover = false"></i>
                                </span>
                                <div class="tax-tooltip" v-show="taxhover">
                                  <i class="fa fa-info"></i> <span class="tooltip-header">Total VAT</span><br>
                                  <p>{{bookingData.data[propertyid].vat.value}}% on rooms, service charges &
                                    enhancements</p>
                                </div>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{ formatPrice(totalVat.res) }} </span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{ formatPrice(totalVat.nonres) }} </span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="cateringLevy.res > 0 || cateringLevy.nonres > 0">
                              <td width="10%" class="prclabel">
                                <b>{{bookingData.data[propertyid].extra_charges.hotel_tax.name}}</b>
                              </td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{formatPrice(cateringLevy.res)}}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{formatPrice(cateringLevy.nonres)}}</span>
                                </div>
                              </td>
                            </tr>
                            <tr
                              v-if="bookingData.data[propertyid].extra_charges.gateway_fee_enabled == 1 && totalGatewayFee.res > 0">
                              <td class="prclabel" width="10%"><b>Total Gateway Fee</b></td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{ formatPrice(totalGatewayFee.res) }}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{ formatPrice(totalGatewayFee.nonres) }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="manageBooking && amountPaid !== '0.00'">
                              <td class="prclabel" width="10%"><b>Paid</b></td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{ formatPrice(amountPaid) }}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{ formatPrice(amountPaid) }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="isLoyaltyUsedOnBooking">
                              <td class="prclabel" width="10%"><b>Paid With Loyalty</b></td>
                              <td width="10%" valign="middle" style="text-align: right">
                                  <div v-if="proofRes == 0">
                                      <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                      <span>{{ -formatPrice(loyaltyAmountPaid) }}</span>
                                  </div>
                                  <div v-if="proofRes == 1">
                                      <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                      <span>{{ -formatPrice(loyaltyAmountPaid) }}</span>
                                  </div>
                              </td>
                          </tr>
                            <tr class="pricetotal">
                              <td class="prclabel" width="10%"><b>Total</b></td>
                              <td width="10%" valign="middle" style="text-align: right">
                                <div v-if="proofRes == 0">
                                  <span>{{ bookingData.data[propertyid].currency.res }}</span>
                                  <span>{{ formatPrice(total.res) }}</span>
                                </div>
                                <div v-if="proofRes == 1">
                                  <span>{{ bookingData.data[propertyid].currency.nonres }}</span>
                                  <span>{{ formatPrice(total.nonres) }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="board && board.extraNights && board.extraNights[resNonRes] !== 0">
                              <td style="text-align: left;">
                                <input type="checkbox" id="acceptExtraNights" @click="acceptExtraNights()">
                                <label for="acceptExtraNights">Accept {{ board.extraNights[resNonRes] }} extra free
                                  night(s) </label>
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="vat2">
                        <span class="error">* </span> Price {{bookingData.data[propertyid].vat.room_price}} of all govt
                        taxes
                      </div>
                      <div v-if="step == 1">
                        <input type="button" id="summery-submit" class="btn btn-block btn-proceed" value="Continue"
                          :disabled="clicked" @click.prevent="next()" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end -->
      </div>
      <!-- end test -->
    </div>
  </div>
  <!-- end new -->
</template>

<script>
import loader from '../components/loader.vue'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import reusableData from '../components/mixins/reusableData'
import reserveportLoyalty from '../components/loyalty'
import moment from 'moment'
import manageBooking from './mixins/manageBooking'
import { EventBus } from './mixins/eventBus'
import { mapState } from 'vuex'
import { pushPlatformEvent, residencyPrice, roomItem } from '../utils/ecommerce'
import { getAttribution } from '../utils/attribution'
  
export default {
  name: 'App',
  components: {
    'loader-terms': loader,
    'reserveport-loyalty': reserveportLoyalty
  },
  data () {
    return {
      proof_of_res_number: '',
      residence_proof_required: false,
      residence_proof_placeholder: '',
      proof_of_residency_disabled: true,
      extraCharge: 0,
      selectedBoard: '',
      enhancementspecialrequest: {},
      cancpolicyaccodion: false,
      clicked: false,
      dateshowpayonarrival: '',
      countries: '',
      payablecTotal: 0,
      payOnArrival: 0,
      unit: 1,
      session: 0,
      adultcount: 0,
      childrencount: 0,
      enhancementDetail: [],
      selectedEnhancement: {},
      adults: '',
      children: '',
      childAges: null,
      babies: '',
      pageloader: false,
      surname: '',
      dateOfBirth: '',
      propertyid: '',
      pendingAmount: 0,
      discount_value: 0,
      discount_terms: '',
      accordion: false,
      deposit: 0,
      proofRes: 0,
      residency: '',
      servicechrg: false,
      taxhover: false,
      showBookingSummary: true,
      multi_room_book: false,
      Enhancement: false,
      bookingData: null,
      isProcessing: false,
      addedhenancement: null,
      step: 1,
      enhancementprice: 0,
      serviceCharge: 0,
      totalVat: 0,
      cateringLevy: 0,
      enhancementCost: 0,
      total: 0,
      roomPrice: 0,
      subTotal: 0,
      board: null,
      roomprice: 0,
      roomtotal: 0,
      room: null,
      rooms: [],
      submitStatus: null,
      chargeType: 'full',
      Special_request: '',
      purpose_of_visit: '',
      departure_time: '',
      arrival_time: '',
      proof_of_residency: '',
      resNonRes: 'res',
      gender: '',
      currency: '',
      nationality: '',
      phone: '',
      email: '',
      emailConfirm: '',
      last_name: '',
      first_name: '',
      callbackUrl: '',
      spinner: "<i class='fa fa-spinner fa-spin '></i> Processing",
      acceptedterm: '',
      totalGatewayFee: '',
      uniterror: false,
      totalDiscount: '',
      puporseOfVistError: false,
      nationalityError: false,
      proofOfResidencyError: false,
      genderError: false,
      arrivalTimeError: false,
      departureTimeError: false,
      proofOfResNumber: false,
      surchargetype: {},
      updatedPrices: {},
      derpatureTimelist: [],
      arrivalTimelist: [],
      ipnProfile: '',
      consumerKey: '',
      secretKey: '',
      postUrl: '',
      ppKey: '',
      ppSecret: '',
      manageBooking: this.$route.query.manage,
      modifyBookingDetails: this.$store.getters.bookingDetails,
      dateChangeExtraPay: '',
      amountPaid: '',
      acceptExtraNightsCheck: false,
      isvalidPhone: false,
      isLoyaltyUsedOnBooking: false,
      loyaltyAmountPaid: 0,
      loyaltyIsEnabled: this.$store.getters.getIsLoyaltyEnabled,
    }
  },
  validations: {
    first_name: { required },
    last_name: { required },
    email: { required, email },
    emailConfirm: { required, sameAs: sameAs('email') },
    chargeType: { required },
    phone: { required },
    acceptedterm: { required }
  },
  created() {
    EventBus.$on('updateLoyaltyPayDetails', loyaltyAmountPaid => {
      this.loyaltyAmountPaid = loyaltyAmountPaid
      this.payOnArrival = parseFloat(this.payOnArrival) - parseFloat(loyaltyAmountPaid)
      this.payablecTotal = parseFloat(this.payablecTotal) - parseFloat(loyaltyAmountPaid)
      this.isLoyaltyUsedOnBooking = true
    });
  },
  computed: {
    specialRequestPlaceholder () {
      if (this.bookingData.data[this.propertyid].guest_form_settings.special_request.length > 0) {
        return this.bookingData.data[this.propertyid].guest_form_settings.special_request
      } else {
        return ''
      }
    },
    ...mapState({
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate
    }),
    bookingCurrency () {
      return this.proofRes == 0 ? this.bookingData.data[this.propertyid].currency.res : this.bookingData.data[this.propertyid].currency.nonres
    }
  },
  watch: {
    arrival_time () {
      if (this.arrivalTimeError && this.arrival_time !== '') {
        this.arrivalTimeError = false
      } else if (!this.arrivalTimeError && this.arrival_time === '') {
        this.arrivalTimeError = true
      }
    },
    departure_time () {
      if (this.departureTimeError && this.departure_time !== '') {
        this.departureTimeError = false
      } else if (!this.departureTimeError && this.departure_time === '') {
        this.departureTimeError = true
      }
    },
    nationality () {
      if (this.nationalityError && this.nationality !== '') {
        this.nationalityError = false
      } else if (!this.nationalityError && this.nationality === '') {
        this.nationalityError = true
      }
    },
    purpose_of_visit () {
      if (this.puporseOfVistError && this.purpose_of_visit !== '') {
        this.puporseOfVistError = false
      } else if (!this.puporseOfVistError && this.purpose_of_visit === '') {
        this.puporseOfVistError = true
      }
    },
    proof_of_residency () {
      if (this.proofOfResidencyError && this.proof_of_residency !== '') {
        this.proofOfResidencyError = false
      } else if (!this.proofOfResidencyError && this.proof_of_residency === '') {
        this.proofOfResidencyError = true
      }
    },
    proof_of_res_number () {
      if (this.proof_of_residency !== '' && this.proof_of_res_number === '') {
        this.proofOfResNumber = true
      } else {
        this.proofOfResNumber = false
      }
    },
    gender () {
      if (this.genderError && this.gender !== '') {
        this.genderError = false
      } else if (!this.genderError && this.gender === '') {
        this.genderError = true
      }
    }

  },
  beforeMount: async function () {
    // if its a manage booking
    // lets initialize the values of a booking
    // from the response
    if (this.manageBooking) {
      this.initializeManageBookingDetails(this.modifyBookingDetails)
    }
    // end manage booking
    this.resNonRes = this.$store.state.proofRes === 0 ? 'res' : 'nonres'
    if (this.$root.ipn_profile !== undefined) {
      if (this.$root.ipn_profile !== '') {
        this.ipnProfile = this.$root.ipn_profile
      }
    }
    var hash = document.location.hash
    var urlparameters = hash.split('?')[1]
    var propid = urlparameters.split('&')[0]
    // var reference =
    var encodedpid = propid.split('=')[1]
    var reconstructedpid1 = encodedpid.split('%3D')
    var reconstructedpid = reconstructedpid1.join('=')
    this.propertyid = atob(reconstructedpid)
    this.proofRes = this.$store.state.proofRes
    this.residency = this.$store.state.residency
    this.bookingData = this.$store.state.bookings
    this.board = this.$store.state.board
    this.childAges = this.$store.state.childAges
    this.babies = this.$store.state.babies
    this.period = this.$store.state.period
    this.room = this.$store.state.room
    this.adults = this.$store.state.adults
    this.children = this.$store.state.children
    this.roomtotal = this.board.roomPrice
    this.subTotal = this.board.subTotal
    this.roomPrice = this.board.roomPriceAfterDiscount
    this.totalDiscount = this.board.totalDiscount
    this.serviceCharge = this.board.totalServiceCharge
    this.totalVat = this.board.totalVAT
    this.cateringLevy = this.board.totalHotelTax
    this.total = this.board.totalAmountPayable
    this.discount_value = this.board.roomDiscount
    this.discount_terms = this.board.roomCoupons.length > 0 ? this.board.roomCoupons[0].terms : ''
    this.totalGatewayFee = this.board.totalGatewayFee
    if (this.board.name.toLowerCase() === 'bed only' || this.board.name.toLowerCase() === 'self catering') {
      this.selectedBoard = 'BO'
    } else if (this.board.name.toLowerCase() === 'bed & breakfast') {
      this.selectedBoard = 'BB'
    } else if (this.board.name.toLowerCase() === 'half board') {
      this.selectedBoard = 'HB'
    } else if (this.board.name.toLowerCase() === 'fullboard') {
      this.selectedBoard = 'FB'
    } else if (this.board.name.toLowerCase() === 'all inclusive') {
      this.selectedBoard = 'AI'
    }
    this.fetchEnhancementData()
    this.fetchCountries()
    // genereting departure and arrival time time
    var arrivalTime = this.bookingData.data[this.propertyid].guest_form_settings.checkin_start_time
    arrivalTime = this.generatingArrivalTime(arrivalTime)
    var depatureTime = this.bookingData.data[this.propertyid].guest_form_settings.checkout_end_time
    depatureTime = this.generatingDepartureTime(depatureTime)
    for (var i = arrivalTime; i <= 23; i++) {
      var time1 = this.convertTime(i)
      var ampmarrival = ''
      if (i >= 12) {
        ampmarrival = 'PM'
      } else {
        ampmarrival = 'AM'
      }
      var constime1 = time1.toString() + ':00 ' + ampmarrival
      var constime = i.toString() + ':00'
      this.arrivalTimelist.push({ 'time24': constime, 'time12': constime1 })
    }
    for (var j = 0; j <= depatureTime; j++) {
      var ampmdepature = ''
      if (j >= 12) {
        ampmdepature = 'PM'
      } else {
        ampmdepature = 'AM'
      }
      time1 = this.convertTime(j)
      constime1 = time1.toString() + ':00 ' + ampmdepature
      constime = j.toString() + ':00'
      this.derpatureTimelist.push({ 'time24': constime, 'time12': constime1 })
    }
    //  end
    if (this.proofRes === 0) {
      if (this.manageBooking) {
        const payableTotalOnManage = this.total.res - this.modifyBookingDetails.amount_paid
        this.total.res = payableTotalOnManage
      }
      this.payablecTotal = this.total.res
      let percentageValue = 0
      if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
        percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
      }
      var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
      let flatRateValue = 0
      if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
        flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
      }
      var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
      var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
      if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
        this.extraCharge = payonarrivalue1
        this.payOnArrival = payonarrivaltotalpercentage
        this.surchargetype[this.room.id] = [{
          type: 2,
          nonres: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres,
          res: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
        }]
      } else {
        this.extraCharge = parseFloat(flatRateValue)
        this.payOnArrival = payonarrivaltotalflatrate
        this.surchargetype[this.room.id] = [{
          type: 1,
          nonres: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres,
          res: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
        }]
      }
    } else if (this.proofRes === 1) {
      if (this.manageBooking) {
        const payableTotalOnManage = this.total.nonres - this.modifyBookingDetails.amount_paid
        this.total.nonres = payableTotalOnManage
      }
      this.payablecTotal = this.total.nonres
      let percentageNonresVal = 0
      if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
        percentageNonresVal = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
      }
      let flatRateVal = 0
      if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
        flatRateVal = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
      }
      payonarrivalue1 = percentageNonresVal / 100 * this.payablecTotal
      payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
      payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateVal)
      if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
        this.extraCharge = payonarrivalue1
        this.payOnArrival = payonarrivaltotalpercentage
        this.surchargetype[this.room.id] = [{
          type: 2,
          nonres: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres,
          res: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
        }]
      } else {
        this.extraCharge = parseFloat(flatRateVal)
        this.payOnArrival = payonarrivaltotalflatrate
        this.surchargetype[this.room.id] = [{
          type: 1,
          nonres: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres,
          res: this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
        }]
      }
    }

    this.$store.dispatch('updatedTotal', this.total)
    this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
    if (this.board.is_special_offer_rate) {
      this.deposit = this.board.special_rate_percentage / 100 * this.payablecTotal
    }
    if (this.bookingData.data[this.propertyid].default_payment_option === 0) {
      this.chargeType = 'full'
    } else if (this.bookingData.data[this.propertyid].default_payment_option === 1) {
      this.chargeType = 'deposit'
    } else if (this.bookingData.data[this.propertyid].default_payment_option === 2) {
      this.chargeType = 'offline'
    }
    this.getPropertyDetails()
    this.dateshowpayonarrival = moment().add(this.bookingData.data[this.propertyid].pay_on_arrival_prior_days, 'days').format('YYYY-MM-DD')
    this.$store.commit('CLEAR_LOYALTY_DETAILS')
  },
  methods: {
    editSelection () {
      this.$router.go(-1)
    },
    async getPropertyDetails () {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        this.secretKey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
        this.consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let fetchUrl = details.url
        this.postUrl = fetchUrl // `${fetchUrl}/index.php`
        this.ppKey = configData[0].val_pesapal_Key// process.env.CONSUMER_PESAPAL_KEY[this.propertyid].key
        this.ppSecret = configData[0].val_pesapal_Secret// process.env.CONSUMER_PESAPAL_SECRET[this.propertyid].secret
      }
    },
    proofOfRes (type) {
      this.residence_proof_required = true
      this.proof_of_residency_disabled = false
      if (type === 1) {
        this.residence_proof_placeholder = 'Enter Your ID number'
      } else {
        this.residence_proof_placeholder = 'Enter Your passport number'
      }
    },
    openAccordion () {
      if (this.accordion === true) {
        this.accordion = false
      } else {
        this.accordion = true
      }
    },
    // function to convert time from 24 hr to 12 hrs
    convertTime (time) {
      var hour = time % 12
      if (time % 12 === 0) {
        hour = 12
      }
      return hour
    },
    generatingArrivalTime (time) {
      time = time.split(':')
      var hour = parseInt(time[0])
      return hour
    },
    generatingDepartureTime (time) {
      time = time.split(':')
      var hour = parseInt(time[0])
      return hour
    },
    opencancelAccordion () {
      if (this.cancpolicyaccodion === true) {
        this.cancpolicyaccodion = false
      } else {
        this.cancpolicyaccodion = true
      }
    },
    next () {
      if (this.step === 1) {
        this.trackCartAndCheckout()
      }
      this.step = 2
      document.body.scrollTop = 1
      document.documentElement.scrollTop = 1
    },
    trackCartAndCheckout () {
      // add_to_cart already fired on the "Book Now" click (redirectToBookDetail);
      // this step only marks the start of the checkout form.
      pushPlatformEvent('begin_checkout', {
        hotel_id: this.propertyid,
        hotel_name: this.bookingData.data[this.propertyid].name,
        currency: this.bookingCurrency,
        value: residencyPrice(this.total, this.proofRes),
        items: [roomItem(this.room, this.board, residencyPrice(this.roomtotal, this.proofRes), 1)]
      })
    },
    // add enhancement methods
    addEnhancement (event, enhancement) {
      if (event.target.checked) {
        const loader = document.getElementById('loading-' + enhancement.id)
        const loaderCover = document.getElementById('loading-cover-' + enhancement.id)
        loaderCover.style.opacity = 0.3
        loader.style.display = 'block'
        var children = document.getElementById('children' + enhancement.id)
        var childrenValue = 0
        if (children !== null) {
          childrenValue = document.getElementById('children' + enhancement.id).value
        }
        if (children === null) {
          childrenValue = this.children
        }
        var adultValue = 0
        var adult = document.getElementById('adults' + enhancement.id)
        if (adult !== null) {
          adultValue = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
        } else {
          adultValue = this.adults
        }
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          var enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }
        const postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: 1,
            enhancement_adults: adultValue,
            enhancement_children: childrenValue,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        var postData = JSON.stringify(postdata)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        if (adultValue > 0 && enhancement.adultsAllowed) {
          var url = `${this.postUrl}index.php?option=com_goreserva_psearch&task=api.getPropertyEnhancements&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              let responseData = response.data.er
              let decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: 1,
                special_request: enhancementSpecialRequest,
                adult: adultValue,
                children: childrenValue
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              enhancement.enhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        }
      } else {
        const loader = document.getElementById('loading-' + enhancement.id)
        const loaderCover = document.getElementById('loading-cover-' + enhancement.id)
        loaderCover.style.opacity = 0.3
        loader.style.display = 'block'
        children = document.getElementById('children' + enhancement.id)
        childrenValue = 0
        if (children !== null) {
          childrenValue = document.getElementById('children' + enhancement.id).value
        }
        if (children === null) {
          childrenValue = this.children
        }
        adultValue = 0
        adult = document.getElementById('adults' + enhancement.id)
        if (adult !== null) {
          adultValue = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
        } else {
          adultValue = this.adults
        }
        passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }
        const postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: 0,
            enhancement_adults: adultValue,
            enhancement_children: childrenValue,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        postData = JSON.stringify(postdata)
        encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        if (adultValue > 0 && enhancement.adultsAllowed) {
          url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeEnhancement&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              var responseData = response.data.er
              var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: 1,
                special_request: enhancementSpecialRequest,
                adult: adultValue,
                children: childrenValue
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              enhancement.enhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              var finalenhancementprice = data.enhancementPrice
              if (Object.keys(finalenhancementprice).length !== 0) {
                enhancement.enhancementprice = data.enhancementPrice
                if (finalenhancementprice.res === 0 || finalenhancementprice.nonres === 0) {
                  delete this.selectedEnhancement[enhancement.id]
                }
              } else {
                enhancement.enhancementprice = 0
                if (adultValue === 0 && childrenValue === 0) {
                  delete this.selectedEnhancement[enhancement.id]
                } else {
                  delete this.selectedEnhancement[enhancement.id]
                }
              }
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        }
      }
    },
    addChildren (enhancement) {
      this.clicked = true
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var childrenval = parseInt(document.getElementById('children' + enhancement.id).value, 10)
      if (enhancement.childrenAllowed > childrenval) {
        var session = document.getElementById('session' + enhancement.id)
        var unit = document.getElementById('unit' + enhancement.id)
        var enhancementQty = 0
        if (session !== null) {
          var sessionval = parseInt(document.getElementById('session' + enhancement.id).value, 10)
          enhancementQty = sessionval
        }
        if (unit !== null) {
          var unitval = parseInt(document.getElementById('unit' + enhancement.id).value, 10)
          enhancementQty = unitval
        }
        if (enhancementQty > 0) {
          childrenval = isNaN(childrenval) ? 0 : childrenval
          childrenval++
          var chilrenvalupdated = document.getElementById('children' + enhancement.id).value = childrenval
          var adultval = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
          var passkey = this.secretKey //  process.env.SECRET_KEY[this.propertyid].key
          if (this.enhancementspecialrequest[enhancement.id] === undefined) {
            var enhancementSpecialRequest = ''
          } else {
            enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
          }
          var postdata = {
            adults: this.adults,
            children: this.children,
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            boards: this.selectedBoard,
            selectedEnhancement: {
              enhancement_id: enhancement.id,
              enhancement_no: enhancement.id,
              enhancement_qty: enhancementQty,
              enhancement_adults: adultval,
              enhancement_children: chilrenvalupdated,
              enhancement_babies: 0,
              residency: this.residency,
              totalRoomPrice: this.roomtotal,
              totalDiscount: this.totalDiscount,
              subTotal: this.subTotal,
              totalServiceCharge: this.serviceCharge,
              totalHotelTax: this.cateringLevy,
              totalVAT: this.totalVat,
              totalGatewayFee: this.totalGatewayFee,
              totalAmountPayable: this.total
            }
          }
          var postData = JSON.stringify(postdata)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
          var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.getPropertyEnhancements&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              var responseData = response.data.er
              var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: enhancementQty,
                special_request: enhancementSpecialRequest,
                adult: adultval,
                children: chilrenvalupdated
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              enhancement.enhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              setTimeout(() => {
                this.clicked = false
              }, 1000)
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        } else {
          this.uniterror = enhancement.id
          this.clicked = false
          loader.style.display = 'none'
          loaderCover.style.opacity = 1
        }
      }
    },
    removeChildren (enhancement) {
      this.uniterror = false
      this.clicked = true
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var childrenid = 'children' + enhancement.id
      var childrenval = parseInt(document.getElementById(childrenid).value, 10)
      if (childrenval > 0) {
        childrenval = isNaN(childrenval) ? 0 : childrenval
        childrenval--
        document.getElementById(childrenid).value = childrenval
        var chilrenvalupdated = document.getElementById('children' + enhancement.id).value = childrenval
        var session = document.getElementById('session' + enhancement.id)
        var unit = document.getElementById('unit' + enhancement.id)
        var enhancementQty = 0
        if (session !== null) {
          var sessionval = parseInt(document.getElementById('session' + enhancement.id).value, 10)
          enhancementQty = sessionval
        }
        if (unit !== null) {
          var unitval = parseInt(document.getElementById('unit' + enhancement.id).value, 10)
          enhancementQty = unitval
        }
        var adultval = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
        ++this.childrencount
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          var enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }

        var postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: enhancementQty,
            enhancement_adults: adultval,
            enhancement_children: chilrenvalupdated,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        var postData = JSON.stringify(postdata)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeEnhancement&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            var responseData = response.data.er
            var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            this.selectedEnhancement[enhancement.id] = {
              data: data,
              id: enhancement.id,
              qty: enhancementQty,
              special_request: enhancementSpecialRequest,
              adult: adultval,
              children: chilrenvalupdated
            }
            this.roomtotal = data.totalRoomPrice
            this.subTotal = data.subTotal
            this.totalDiscount = data.totalDiscount
            this.serviceCharge = data.totalServiceCharge
            this.totalVat = data.totalVAT
            this.cateringLevy = data.totalHotelTax
            this.total = data.totalAmountPayable
            this.discount_value = this.board.roomDiscount
            this.totalGatewayFee = data.totalGatewayFee
            var finalenhancementprice = data.enhancementPrice
            if (this.proofRes === 0) {
              this.payablecTotal = this.total.res
              let percentageValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
              }
              var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
              let flatRateValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
              }
              var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
              var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
              if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                this.payOnArrival = payonarrivaltotalpercentage
              } else {
                this.payOnArrival = payonarrivaltotalflatrate
              }
            } else {
              this.payablecTotal = this.total.nonres
              let percentageValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
              }
              let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
              let flatRateValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
              }
              payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
              payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
              if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                this.payOnArrival = payonarrivaltotalpercentage
              } else {
                this.payOnArrival = payonarrivaltotalflatrate
              }
            }
            if (Object.keys(finalenhancementprice).length !== 0) {
              enhancement.enhancementprice = data.enhancementPrice
              if (finalenhancementprice.res === 0 || finalenhancementprice.nonres === 0) {
                delete this.selectedEnhancement[enhancement.id]
              }
            } else {
              enhancement.enhancementprice = 0
              if (adultval === 0 && chilrenvalupdated === 0) {
                delete this.selectedEnhancement[enhancement.id]
              }
            }
            this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
            this.clicked = false
            loader.style.display = 'none'
            loaderCover.style.opacity = 1
          })
          .catch((err) => {
            console.log('error', err)
          })
      } else {
        this.clicked = false
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    addAdult (enhancement) {
      this.uniterror = false
      this.clicked = true
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var adultid = 'adults' + enhancement.id
      var adultval = parseInt(document.getElementById(adultid).value, 10)

      if (enhancement.adultsAllowed && adultval < enhancement.adult_total) {
        var session = document.getElementById('session' + enhancement.id)
        var unit = document.getElementById('unit' + enhancement.id)
        var Qty = 0
        if (session !== null) {
          var sessionval = parseInt(document.getElementById('session' + enhancement.id).value, 10)
          Qty = sessionval
        }
        if (unit !== null) {
          var unitval = parseInt(document.getElementById('unit' + enhancement.id).value, 10)
          Qty = unitval
        }

        if (Qty > 0) {
          adultval = isNaN(adultval) ? 0 : adultval
          adultval++
          document.getElementById(adultid).value = adultval
          var selectedChildren = document.getElementById('children' + enhancement.id)
          var chilrenvalupdated = 0
          if (selectedChildren !== null) {
            chilrenvalupdated = parseInt(document.getElementById('children' + enhancement.id).value, 10)
          }
          ++this.childrencount
          var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
          if (this.enhancementspecialrequest[enhancement.id] === undefined) {
            var enhancementSpecialRequest = ''
          } else {
            enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
          }
          var postdata = {
            adults: this.adults,
            children: this.children,
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            boards: this.selectedBoard,
            selectedEnhancement: {
              enhancement_id: enhancement.id,
              enhancement_no: enhancement.id,
              enhancement_qty: Qty,
              enhancement_adults: adultval,
              enhancement_children: chilrenvalupdated,
              enhancement_babies: 0,
              residency: this.residency,
              totalRoomPrice: this.roomtotal,
              totalDiscount: this.totalDiscount,
              subTotal: this.subTotal,
              totalServiceCharge: this.serviceCharge,
              totalHotelTax: this.cateringLevy,
              totalVAT: this.totalVat,
              totalGatewayFee: this.totalGatewayFee,
              totalAmountPayable: this.total
            }
          }
          var postData = JSON.stringify(postdata)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
          var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.getPropertyEnhancements&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              var responseData = response.data.er
              var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: Qty,
                special_request: enhancementSpecialRequest,
                adult: adultval,
                children: chilrenvalupdated
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              enhancement.enhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              this.clicked = false
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        } else {
          this.uniterror = enhancement.id
          this.clicked = false
          loader.style.display = 'none'
          loaderCover.style.opacity = 1
        }
      } else {
        this.clicked = false
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    removeAdult (enhancement) {
      this.uniterror = false
      this.clicked = true
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var adultid = 'adults' + enhancement.id
      var adultval = parseInt(document.getElementById(adultid).value, 10)
      if (adultval > 0) {
        adultval = isNaN(adultval) ? 0 : adultval
        adultval--
        document.getElementById(adultid).value = adultval
        var selectedChildren = document.getElementById('children' + enhancement.id)
        var chilrenvalupdated = 0
        if (selectedChildren !== null) {
          chilrenvalupdated = parseInt(document.getElementById('children' + enhancement.id).value, 10)
        }
        var session = document.getElementById('session' + enhancement.id)
        var unit = document.getElementById('unit' + enhancement.id)
        var enhancementQty = 0
        if (session !== null) {
          var sessionval = parseInt(document.getElementById('session' + enhancement.id).value, 10)
          enhancementQty = sessionval
        }
        if (unit !== null) {
          var unitval = parseInt(document.getElementById('unit' + enhancement.id).value, 10)
          enhancementQty = unitval
        }
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          var enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }
        var postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: enhancementQty,
            enhancement_adults: adultval,
            enhancement_children: chilrenvalupdated,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        var postData = JSON.stringify(postdata)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeEnhancement&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            var responseData = response.data.er
            var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            this.selectedEnhancement[enhancement.id] = {
              data: data,
              id: enhancement.id,
              qty: enhancementQty,
              special_request: enhancementSpecialRequest,
              adult: adultval,
              children: chilrenvalupdated
            }
            this.roomtotal = data.totalRoomPrice
            this.subTotal = data.subTotal
            this.totalDiscount = data.totalDiscount
            this.serviceCharge = data.totalServiceCharge
            this.totalVat = data.totalVAT
            this.cateringLevy = data.totalHotelTax
            this.total = data.totalAmountPayable
            this.discount_value = this.board.roomDiscount
            this.totalGatewayFee = data.totalGatewayFee
            let finalenhancementprice = data.enhancementPrice
            if (this.proofRes === 0) {
              this.payablecTotal = this.total.res
              let percentageValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
              }
              var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
              let flatRateValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
              }
              var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
              var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
              if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                this.payOnArrival = payonarrivaltotalpercentage
              } else {
                this.payOnArrival = payonarrivaltotalflatrate
              }
            } else {
              this.payablecTotal = this.total.nonres
              let percentageValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
              }
              let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
              let flatRateValue = 0
              if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
              }
              payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
              payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
              if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                this.payOnArrival = payonarrivaltotalpercentage
              } else {
                this.payOnArrival = payonarrivaltotalflatrate
              }
            }
            if (Object.keys(finalenhancementprice).length !== 0) {
              enhancement.enhancementprice = data.enhancementPrice
              if (finalenhancementprice.res === 0 || finalenhancementprice.nonres === 0) {
                delete this.selectedEnhancement[enhancement.id]
              }
            } else {
              enhancement.enhancementprice = 0
              if (adultval === 0 && chilrenvalupdated === 0) {
                delete this.selectedEnhancement[enhancement.id]
              }
            }
            this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
            this.clicked = false
            loader.style.display = 'none'
            loaderCover.style.opacity = 1
          })
          .catch((err) => {
            console.log('error', err)
          })
      } else {
        this.clicked = false
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    addUnit (enhancement) {
      this.uniterror = false
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      this.clicked = true
      var unitid = 'unit' + enhancement.id
      var unitval = parseInt(document.getElementById(unitid).value, 10)
      if (enhancement.unit.maximumLimit > unitval) {
        unitval = isNaN(unitval) ? 0 : unitval
        unitval++
        document.getElementById(unitid).value = unitval
        var children = document.getElementById('children' + enhancement.id)
        let childrenValue = 0
        if (children !== null) {
          childrenValue = document.getElementById('children' + enhancement.id).value
        } else {
          childrenValue = this.children
        }
        let adultValue = 0
        var adult = document.getElementById('adults' + enhancement.id)
        if (adult !== null) {
          adultValue = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
        } else {
          adultValue = this.adults
        }
        ++this.childrencount
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          var enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }
        var postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: unitval,
            enhancement_adults: adultValue,
            enhancement_children: childrenValue,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        var postData = JSON.stringify(postdata)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        if (adultValue > 0 && adultValue < enhancement.adult_total) {
          var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.getPropertyEnhancements&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              var responseData = response.data.er
              var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: unitval,
                special_request: enhancementSpecialRequest,
                adult: adultValue,
                children: childrenValue
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              enhancement.enhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              this.clicked = false
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        } else {
          this.clicked = false
          loader.style.display = 'none'
          loaderCover.style.opacity = 1
        }
      } else {
        this.clicked = false
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    removeUnit (enhancement) {
      this.clicked = true
      var loader = document.getElementById('loading-' + enhancement.id)
      var loaderCover = document.getElementById('loading-cover-' + enhancement.id)
      loaderCover.style.opacity = 0.3
      loader.style.display = 'block'
      var unitid = 'unit' + enhancement.id
      var unitval = parseInt(document.getElementById(unitid).value, 10)
      if (unitval > 0) {
        unitval = isNaN(unitval) ? 0 : unitval
        unitval--
        document.getElementById(unitid).value = unitval
        var children = document.getElementById('children' + enhancement.id)
        var childrenValue = 0
        if (children !== null) {
          childrenValue = document.getElementById('children' + enhancement.id).value
        } else {
          childrenValue = this.children
        }
        var adultValue = 0
        var adult = document.getElementById('adults' + enhancement.id)
        if (adult !== null) {
          adultValue = parseInt(document.getElementById('adults' + enhancement.id).value, 10)
        } else {
          adultValue = this.adults
        }
        var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
        if (this.enhancementspecialrequest[enhancement.id] === undefined) {
          var enhancementSpecialRequest = ''
        } else {
          enhancementSpecialRequest = this.enhancementspecialrequest[enhancement.id]
        }
        var postdata = {
          adults: this.adults,
          children: this.children,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          boards: this.selectedBoard,
          selectedEnhancement: {
            enhancement_id: enhancement.id,
            enhancement_no: enhancement.id,
            enhancement_qty: unitval,
            enhancement_adults: adultValue,
            enhancement_children: childrenValue,
            enhancement_babies: 0,
            residency: this.residency,
            totalRoomPrice: this.roomtotal,
            totalDiscount: this.totalDiscount,
            subTotal: this.subTotal,
            totalServiceCharge: this.serviceCharge,
            totalHotelTax: this.cateringLevy,
            totalVAT: this.totalVat,
            totalGatewayFee: this.totalGatewayFee,
            totalAmountPayable: this.total
          }
        }
        var postData = JSON.stringify(postdata)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postData)
        if (adultValue > 0 || childrenValue > 0) {
          var url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.removeEnhancement&pid=${this.propertyid}&consumer_key=${this.consumerKey}&data=${encryptedData}`
          this.axios
            .get(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              var responseData = response.data.er
              var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
              return JSON.parse(decryptedData)
            })
            .then((data) => {
              this.selectedEnhancement[enhancement.id] = {
                data: data,
                id: enhancement.id,
                qty: unitval,
                special_request: enhancementSpecialRequest,
                adult: adultValue,
                children: childrenValue
              }
              this.roomtotal = data.totalRoomPrice
              this.subTotal = data.subTotal
              this.totalDiscount = data.totalDiscount
              this.serviceCharge = data.totalServiceCharge
              this.totalVat = data.totalVAT
              this.cateringLevy = data.totalHotelTax
              this.total = data.totalAmountPayable
              this.discount_value = this.board.roomDiscount
              this.totalGatewayFee = data.totalGatewayFee
              var finalenhancementprice = data.enhancementPrice
              if (this.proofRes === 0) {
                this.payablecTotal = this.total.res
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.res
                }
                var payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.res
                }
                var payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                var payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              } else {
                this.payablecTotal = this.total.nonres
                let percentageValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres !== '') {
                  percentageValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.percentage.nonres
                }
                let payonarrivalue1 = percentageValue / 100 * this.payablecTotal
                let flatRateValue = 0
                if (this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres !== '') {
                  flatRateValue = this.bookingData.data[this.propertyid].pay_on_arrival_surcharge.flat_rate.nonres
                }
                payonarrivaltotalpercentage = parseFloat(this.payablecTotal) + parseFloat(payonarrivalue1)
                payonarrivaltotalflatrate = parseFloat(this.payablecTotal) + parseFloat(flatRateValue)
                if (payonarrivaltotalpercentage > payonarrivaltotalflatrate) {
                  this.payOnArrival = payonarrivaltotalpercentage
                } else {
                  this.payOnArrival = payonarrivaltotalflatrate
                }
              }
              if (Object.keys(finalenhancementprice).length !== 0) {
                enhancement.enhancementprice = data.enhancementPrice
                if (finalenhancementprice.res === 0 || finalenhancementprice.nonres === 0) {
                  delete this.selectedEnhancement[enhancement.id]
                }
              } else {
                enhancement.enhancementprice = 0
                if (adultValue === 0 || childrenValue === 0) {
                  delete this.selectedEnhancement[enhancement.id]
                } else if (unitval === 0) {
                  delete this.selectedEnhancement[enhancement.id]
                }
              }
              this.deposit = this.bookingData.data[this.propertyid].deposit_percentage / 100 * this.payablecTotal
              this.clicked = false
              loader.style.display = 'none'
              loaderCover.style.opacity = 1
            })
            .catch((err) => {
              console.log('error', err)
            })
        } else {
          this.clicked = false
          loader.style.display = 'none'
          loaderCover.style.opacity = 1
        }
      } else {
        this.clicked = false
        loader.style.display = 'none'
        loaderCover.style.opacity = 1
      }
    },
    addspecialrequest (event, enhancement) {
      this.enhancementspecialrequest[enhancement.id] = event.target.value
    },
    validateForm () {
      if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.allow_checkin_selection) === 1 && parseInt(this.bookingData.data[this.propertyid].guest_form_settings.allow_checkout_selection) === 1) {
        if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.checkin_selection_mandatory) === 1 && this.arrival_time === '') {
          this.arrivalTimeError = true
        } else {
          this.arrivalTimeError = false
        }
        if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.checkout_selection_mandatory) === 1 && this.departure_time === '') {
          this.departureTimeError = true
        } else {
          this.departureTimeError = false
        }
      }
      if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.proof_of_residency_selection) === 2 && this.proof_of_residency === '') {
        this.proofOfResidencyError = true
      } else {
        this.proofOfResidencyError = false
      }
      if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.purpose_of_visit_selection) === 2 && this.purpose_of_visit === '') {
        this.puporseOfVistError = true
      } else {
        this.puporseOfVistError = false
      }
      if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.nationality_selection) === 2 && this.nationality === '') {
        this.nationalityError = true
      } else {
        this.nationalityError = false
      }
      if (parseInt(this.bookingData.data[this.propertyid].guest_form_settings.gender_selection) === 2 && this.gender === '') {
        this.genderError = true
      } else {
        this.genderError = false
      }
      if (this.proof_of_residency !== '' && this.proof_of_res_number === '') {
        this.proofOfResNumber = true
      } else {
        this.proofOfResNumber = false
      }
      if (this.genderError === true || this.nationalityError === true ||
                this.puporseOfVistError === true || this.proofOfResidencyError === true ||
                this.departureTimeError === true || this.arrivalTimeError === true || this.proofOfResNumber === true) {
        return false
      } else {
        return true
      }
    },
    async completeBook () {
      this.$v.$touch()
      const isValid = this.validateForm()
      // if its manageBooking, don't do checks
      if (this.manageBooking ? true : isValid) {
        if (this.manageBooking ? true : !this.$v.$invalid) {
          if (this.acceptedterm !== '') {
            var totalpriceBook = 0
            var couponDiscountAmount = 0
            var totalAmount = 0
            var serviceCharges = 0
            var cateringLevy = 0
            var totalVat = 0
            var totalGatewayFee = 0
            var childrenDailyRate = 0
            var adultDailyRate = 0
            var totalDailyRate = 0
            var dailyDiscount = 0
            if (this.proofRes === 0) {
              this.currency = this.bookingData.data[this.propertyid].currency.res
              totalpriceBook = this.board.roomPrice.res
              couponDiscountAmount = this.board.totalDiscount.res
              totalAmount = this.total.res
              serviceCharges = this.serviceCharge.res
              totalVat = this.totalVat.res
              cateringLevy = this.cateringLevy.res
              totalGatewayFee = this.totalGatewayFee.res
              adultDailyRate = this.board.roomPrice.daily.adults.res
              childrenDailyRate = this.board.roomPrice.daily.children.res
              totalDailyRate = this.board.roomPrice.daily.res
              dailyDiscount = this.board.roomDiscount.daily.res
            } else {
              this.currency = this.bookingData.data[this.propertyid].currency.nonres
              totalpriceBook = this.board.roomPrice.nonres
              couponDiscountAmount = this.board.totalDiscount.nonres
              totalAmount = this.total.nonres
              serviceCharges = this.serviceCharge.nonres
              totalVat = this.totalVat.nonres
              cateringLevy = this.cateringLevy.nonres
              totalGatewayFee = this.totalGatewayFee.nonres
              adultDailyRate = this.board.roomPrice.daily.adults.nonres
              childrenDailyRate = this.board.roomPrice.daily.children.nonres
              totalDailyRate = this.board.roomPrice.daily.nonres
              dailyDiscount = this.board.roomDiscount.daily.nonres
            }
            // getting amount payable
            var totalAmountPayable = 0
            var depositPercentage = 0
            var deposit = 0
            if (this.chargeType === 'full') {
              totalAmountPayable = this.payablecTotal
            } else if (this.chargeType === 'deposit') {
              totalAmountPayable = this.deposit
              deposit = this.deposit
              depositPercentage = this.bookingData.data[this.propertyid].deposit_percentage
            } else if (this.chargeType === 'offline') {
              totalAmountPayable = this.payOnArrival
            }
            this.isProcessing = true
            this.$store.dispatch('confirmMultiBook', this.multi_room_book)
            let selectedEnhancementDetails = []
            let room = []
            // getting meal plan
            let mealPlan = ''
            if (this.board.name.toLowerCase() === 'bed only' || this.board.name.toLowerCase() === 'bed' || this.board.name.toLowerCase() === 'self catering') {
              mealPlan = 'BO'
            } else if (this.board.name.toLowerCase() === 'bed & breakfast') {
              mealPlan = 'BB'
            } else if (this.board.name.toLowerCase() === 'half board' || this.board.name.toLowerCase() === 'halfboard') {
              mealPlan = 'HB'
            } else if (this.board.name.toLowerCase() === 'full board' || this.board.name.toLowerCase() === 'fullboard') {
              mealPlan = 'FB'
            } else if (this.board.name.toLowerCase() === 'all inclusive') {
              mealPlan = 'AI'
            }
            // looping through selected enhancement
            for (const result of Object.values(this.selectedEnhancement)) {
              if (this.proofRes === 0) {
                selectedEnhancementDetails.push({
                  enhancement_id: result.id,
                  name: result.data.enhancementName,
                  total_price: result.data.enhancementPrice.res,
                  quantity: result.qty,
                  adults: result.adult,
                  children: result.children,
                  special_requests: result.special_request
                })
              } else {
                selectedEnhancementDetails.push({
                  enhancement_id: result.id,
                  name: result.data.enhancementName,
                  total_price: result.data.enhancementPrice.nonres,
                  quantity: result.qty,
                  adults: result.adult,
                  children: result.children,
                  special_requests: result.special_request
                })
              }
            }
            // getting coupon detail
            var couponName = ''
            var couponDetail = {}
            for (const coupon of Object.values(this.room.discount_coupons)) {
              couponDetail = {
                id: coupon.id,
                code: coupon.code,
                name: coupon.code,
                boards: coupon.boards,
                start_date: coupon.start_date,
                end_date: coupon.end_date,
                terms: coupon.terms,
                type: coupon.type
              }
              if (coupon.extranights_res && parseInt(coupon.extranights_res) > 0) {
                couponDetail['extranights_res'] = parseInt(coupon.extranights_res)
              }
              if (coupon.extranights_nonres && parseInt(coupon.extranights_nonres) > 0) {
                couponDetail['extranights_nonres'] = parseInt(coupon.extranights_nonres)
              }
              if (coupon.freenights_res && parseInt(coupon.freenights_res) > 0) {
                couponDetail['freenights_res'] = parseInt(coupon.freenights_res)
              }
              if (coupon.freenights_nonres && parseInt(coupon.freenights_nonres) > 0) {
                couponDetail['freenights_nonres'] = parseInt(coupon.freenights_nonres)
              }
              couponName = coupon.code
            }
            room.push({
              id: this.room.id,
              total_adult: this.adults,
              name: this.room.name,
              no_rooms: 1,
              cguest: this.children,
              children_ages: this.childAges,
              bguest: this.babies,
              meal_plan: mealPlan,
              totalprice_book: totalpriceBook,
              coupon_details: JSON.stringify(couponDetail),
              daily_rates: {
                total: totalDailyRate,
                adults: adultDailyRate,
                children: childrenDailyRate,
                discount: dailyDiscount
              }
            })
            let selectedRoomsDetails = {}
            selectedRoomsDetails[this.room.id] = room
            // array to hold extras
            if (this.chargeType === 'offline') {
              var extras = {
                offline_surcharge: {
                  settings: this.surchargetype,
                  amount: this.extraCharge
                }
              }
            } else {
              extras = {}
            }
            // end
            // store important information for reloading iframe
            const postDataParams = {
              checkInDate: this.checkinDate,
              checkOutDate: this.checkoutDate,
              selectedRooms: selectedRoomsDetails,
              ipn_profile: this.ipnProfile,
              selectedEnhancements: selectedEnhancementDetails,
              currency: this.currency,
              coupon_code: couponName,
              coupon_details: JSON.stringify(couponDetail),
              coupon_discount_amount: couponDiscountAmount,
              amount_paid: this.manageBooking ? this.amountPaid : this.loyaltyAmountPaid ? this.loyaltyAmountPaid : 0,
              total_amount: totalAmount,
              amount_payable: totalAmountPayable,
              vatrate: this.bookingData.data[this.propertyid].vat.value,
              vatvalue: totalVat,
              hotel_tax: cateringLevy,
              service_charge: serviceCharges,
              gateway_fee: totalGatewayFee,
              gateway_fee_included_in_hotel_tax: this.bookingData.data[this.propertyid].extra_charges.gateway_fee_included_in_hotel_tax,
              deposit: depositPercentage,
              pending_amount: totalAmount,
              deposit_amount: deposit,
              exchange_rate: this.bookingData.data[this.propertyid].currency.exchange_rate,
              payment_reference_number: '',
              surname: this.surname,
              firstName: this.first_name,
              lastName: this.last_name,
              email: this.email,
              nationality: this.nationality,
              proof_of_residency: this.proof_of_residency,
              proof_of_res_number: this.proof_of_res_number,
              purpose_of_visit: this.purpose_of_visit,
              phone: this.phone,
              gender: this.gender,
              arrival_time: this.arrival_time,
              departure_time: this.departure_time,
              dietary_restrictions: '',
              mode_of_transport: '',
              mode_of_transport_option: '',
              birth_day: '',
              birth_month: '',
              birth_year: '',
              special_request: this.Special_request,
              property_id: this.propertyid,
              propertyprefix: '',
              http_user: {
                user_agent: '',
                continent_name: '',
                country_name: '',
                country_code: '',
                city: '',
                timezone: '',
                isp: ''
              },
              charge_type: this.chargeType,
              extras: JSON.stringify(extras),
              parent_reference_num: this.manageBooking ? this.modifyBookingDetails.reference_number : '',
              modification_type: this.manageBooking ? this.modifyBookingDetails.modification_type : '',
              drb_source: this.$store.state.drbsource,
              attribution: getAttribution(),
              rate_ids_used: this.board.rateIdsUsed.length > 0 ? this.board.rateIdsUsed : []
              // modification_type: this.manageBooking ? this.modifyBookingDetails.modification_type : ''
            }
            var postDataParamJson = JSON.stringify(postDataParams)
            this.$store.state.loyalty_pay_info = {}
            var passkey = this.secretKey // process.env.SECRET_KEY[this.propertyid].key
            var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataParamJson)
            var propertyPesapalKey = this.ppKey // process.env.CONSUMER_PESAPAL_KEY[this.propertyid].key
            var propertyPesapalSecret = this.ppSecret // process.env.CONSUMER_PESAPAL_SECRET[this.propertyid].secret
            try {
              const formData = new FormData()
              formData.append('pid', this.propertyid)
              formData.append('pk', propertyPesapalKey)
              formData.append('ps', propertyPesapalSecret)
              formData.append('consumer_key', this.consumerKey)
              formData.append('data', encryptedData)
              const url = `${this.postUrl}/index.php?option=com_goreserva_psearch&task=api.postReservation`
              const response = await this.axios.post(url, formData)
              
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)
                const paymentUpdatedpayload = {
                  referenceNumber: data.referenceNumber,
                  rooms: data.rooms,
                  occupancy: data.occupancy,
                  enhancements: data.enhancements,
                  currency: data.currency,
                  totalRoomPrice: data.totalRoomPrice,
                  totalEnhancementPrice: data.totalEnhancementPrice,
                  subTotal: data.subTotal,
                  totalDiscount: data.totalDiscount,
                  totalServiceCharge: data.totalServiceCharge,
                  totalHotelTax: data.totalHotelTax,
                  totalVAT: data.totalVAT,
                  totalGatewayFee: data.totalGatewayFee,
                  totalAmountPayable: data.totalAmountPayable,
                  pid: data.pid,
                  name: data.name,
                  vat: data.vat,
                  extra_charges: data.extra_charges,
                  iframeLink: atob(data.iframeLink),
                  chargeType: this.chargeType
                }
                this.$store.commit('updatePaymentInfo', paymentUpdatedpayload)
                const urlparam = {
                  reference: data.referenceNumber,
                  displayCardMessage: this.bookingData.data[this.propertyid].display_card_msg,
                  chargeType: this.chargeType
                }
                var urlParamJsonp = JSON.stringify(urlparam)
                var encryptedurlparamp = this.CryptoJSAesEncrypt(passkey, urlParamJsonp)
                var encodedDatap = btoa(encryptedurlparamp)
                var currentUrl = window.location.href
                if (this.chargeType !== 'offline') {
                  if (currentUrl.match(/^http?:\/\//i)) {
                    window.location.replace('https://reservations.reserveport.com/#/payment/?pid=' + btoa(this.propertyid) + '&data=' + encodedDatap)
                  } else {
                    this.$router.push({
                      path: '/payment/?pid=' + btoa(this.propertyid) + '&data=' + encodedDatap
                    })
                  }
                }
                if (this.chargeType === 'offline') {
                  const urlparam = {
                    reference: data.referenceNumber
                  }
                  var urlParamJson = JSON.stringify(urlparam)
                  var encryptedurlparam = this.CryptoJSAesEncrypt(passkey, urlParamJson)
                  var encodedData = btoa(encryptedurlparam)
                  this.$router.push({
                    path: '/payment2-complete/?pid=' + btoa(this.propertyid) + '&data=' + encodedData
                  })
                }
                // if it is a manage booking
                // cancel the previous booking
                if (this.manageBooking) {
                  // this.cancelBooking('Booking Details Updated')
                }
                // end cancel
              }
            } catch (error) {
              this.isProcessing = false
            }
            this.submitStatus = 'PENDING'
            setTimeout(() => {
              this.submitStatus = 'OK'
            }, 500)
          } else {
            this.$alert('Please accept terms and conditions before proceeding.', '',
              'warning')
          }
        } else {
          this.submitStatus = 'ERROR'
        }
      }
    },
    // manage booking initialize
    initializeManageBookingDetails (data) {
      this.first_name = data.firstname
      this.last_name = data.lastname
      this.email = data.email
      this.nationality = data.nationality
      this.proof_of_residency = data.proof_of_residency
      this.purpose_of_visit = data.purpose_of_visit
      this.phone = data.cellnumber
      this.gender = data.gender
      this.arrival_time = data.arrival_time
      this.departure_time = data.departure_time
      this.Special_request = data.special_request
      // only have this section
      // if its a date edit specifically
      if (data.new_checkin_date) {
        var datesChangeR = this.$store.getters.datesEditResponse
        var newPriceTotal = datesChangeR.specificroomres
        this.amountPaid = datesChangeR ? datesChangeR.oldPrice.split(' ')[1] : ''
        this.total = newPriceTotal
      }
      // end
    },
    // end of manage booking initialize
    // extra/free Nights
    acceptExtraNights () {
      if (this.board && this.board.extraNights && this.board.extraNights[this.resNonRes]) {
        const extraNights = this.board.extraNights[this.resNonRes]
        const checkoutDateMoment = moment(this.checkOutDate)
        if (this.acceptExtraNightsCheck) {
          this.checkOutDate = checkoutDateMoment.subtract(extraNights, 'days').format('YYYY-MM-DD')
        } else {
          this.checkOutDate = checkoutDateMoment.add(extraNights, 'days').format('YYYY-MM-DD')
        }
        this.acceptExtraNightsCheck = !this.acceptExtraNightsCheck
      }
    },
    verifyPhoneNumber(phoneNumber) {
      var phoneRegex = /^\d{10}$/
      this.isValidPhone = phoneRegex.test(phoneNumber)
    }
  },
  mixins: [reusableData, manageBooking]
}
</script>

<style>
@import '../assets/styles/main.css';
</style>



// WEBPACK FOOTER //
// src/components/BookingDetail.vue